import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import './registerServiceWorker'

// styles
import './scss/app.scss'

// register components
import './components'

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
  router,
  store,
  render: h => h('transition', {
    attrs: {
      name: 'loading-fade',
      mode: 'in-out'
    }
  }, [store.state.loaded ? h(App) : false]),
}).$mount('#app')
